import { ReactNode } from 'react';

import { cn } from '@codes/ui-kit';

const MAX_WIDTH_MAP = {
    sm: 'max-w-3xl',
    md: 'max-w-4xl',
    lg: 'max-w-5xl',
    xl: 'max-w-6xl',
    full: 'max-w-full',
} as const;

interface PageContainerProps {
    children: ReactNode;
    maxWidth?: keyof typeof MAX_WIDTH_MAP;
    className?: string;
    noPadding?: boolean;
}

export const PageContainer = ({ children, maxWidth = 'full', className, noPadding = false }: PageContainerProps) => {
    return (
        <div className={cn('w-full mx-auto', MAX_WIDTH_MAP[maxWidth], !noPadding && 'py-8 px-8 max-md:p-4', className)}>
            {children}
        </div>
    );
};
